import { CalendarCreatePage } from '../pages/CalendarCreatePage';
import { CalendarListPage } from '../pages/CalendarListPage';
// カレンダー管理
export const enqueteCalendarRoute = {
  path: 'enquete-calendar',
  children: [
    // コンプライアンス・レビュー カレンダー管理画面
    {
      path: '',
      element: <CalendarListPage />,
    },
    // コンプライアンス・レビュー カレンダー予定登録画面(新規)
    {
      path: 'calendar-edit',
      element: <CalendarCreatePage />,
    },
    // コンプライアンス・レビュー カレンダー予定登録画面(編集)
    {
      path: 'calendar-edit/:calendarId',
      element: <CalendarCreatePage />,
    },
  ],
};
